export default function getPathWithUrlBase(path) {
  return `${window.Lidarr.urlBase}${path}`;
}
